import { Palette } from '@ppwr/poker'
import * as React from 'react'
import Svg, { Rect, Path } from 'react-native-svg'
import { useResponsive } from '@/screens/new-design/hooks'

interface CloseSVGProps {
  bgFill?: string
  iconFill?: string
}

export const CloseSVG = ({
  bgFill = Palette['Brand/Cream'],
  iconFill = Palette['Global/Black'],
  ...rest
}: React.ComponentProps<typeof Svg> & CloseSVGProps) => {
  const { verticalScale } = useResponsive()
  return (
    <Svg width={verticalScale(40)} height={verticalScale(40)} viewBox="0 0 40 40" fill="none" {...rest}>
      <Rect width={40} height={40} rx={20} fill={bgFill} />
      <Path
        d="M25.7366 15.7365C26.1434 15.3298 26.1434 14.6702 25.7366 14.2634C25.3298 13.8566 24.6703 13.8566 24.2635 14.2634L20 18.5268L15.7366 14.2634C15.3298 13.8566 14.6703 13.8566 14.2635 14.2634C13.8567 14.6702 13.8567 15.3298 14.2635 15.7365L18.5269 20L14.2635 24.2634C13.8567 24.6702 13.8567 25.3298 14.2635 25.7365C14.6703 26.1433 15.3298 26.1433 15.7366 25.7365L20 21.4731L24.2635 25.7365C24.6703 26.1433 25.3298 26.1433 25.7366 25.7365C26.1434 25.3298 26.1434 24.6702 25.7366 24.2634L21.4732 20L25.7366 15.7365Z"
        fill={iconFill}
      />
    </Svg>
  )
}
